// extracted by mini-css-extract-plugin
export default {"imageContainer":"Y1-z","summaryPar":"Z1-z","ratingCategories":"_1-z","reviewerInfo":"a2-z","reviewTypes":"b2-z","expanded":"c2-z"};